import React, { useState } from "react";
import { Button, Card, Col, Row } from "react-bootstrap";
import { Link } from "react-router-dom";
import SplitNumber from "../../../components/SplitNumber";
import { isMobile } from "react-device-detect";
import Skeleton from "react-loading-skeleton";
import AddToBasketRoundedButton from "../../../components/addToBasketRoundedButton";
import useLazyLoad from "../../../components/LazyImage";
import placeHolderimage from "../../../../assets/images/load-image.jpg";
import {
  IconBasket1,
  IconErrorCircle,
  IconTooman,
} from "../../../../assets/icons";
function CardItem({
  imageUrl,
  amusementName,
  price,
  amusementUrl,
  originalPrice,
  hasReserveDetail_V2,
}) {
  const [loaded, setLoaded] = useState(false);
  const [isImageLoaded, setIsImageLoaded] = useState(false);
  const [ref, inView] = useLazyLoad({ threshold: 0.1 }); // وقتی 10% المان در viewport باشد
  return isMobile ? (
    <Col xs="6" sm="4" md="3" className="mt-2">
      <Link to={amusementUrl}>
        <Card className="bg-white shadow-sm rounded-3 p-1 h-100">
          <Card.Body className="p-0 text-center">
            <div>
              <div
                ref={ref}
                style={{ position: "relative", width: "100%", height: "108px" }}
              >
                {/* تصویر پیش‌فرض (همیشه نمایش داده می‌شود) */}
                <img
                  src={placeHolderimage}
                  data-src={`${imageUrl}?width=200`}
                  altBot={amusementName}
                  alt=""
                  aria-hidden="true"
                  className="rounded-3 mb-1 w-100"
                  style={{
                    display: isImageLoaded ? "none" : "block", // پس از لود عکس اصلی، مخفی می‌شود
                    objectFit: "cover",
                    height: "100%",
                    backgroundColor: "#f5f5f5", // رنگ پس‌زمینه برای حالت Placeholder
                  }}
                />

                {/* تصویر اصلی (فقط وقتی در viewport باشد لود می‌شود) */}
                {inView && (
                  <>
                    <img
                      src={`${imageUrl}?width=200`}
                      alt={amusementName}
                      className={`rounded-3 mb-1 w-100 ${
                        isImageLoaded ? "visible" : "invisible"
                      }`}
                      loading="lazy"
                      onLoad={() => setIsImageLoaded(true)} // وقتی عکس لود شد، state را آپدیت می‌کند
                      style={{
                        position: "absolute",
                        top: 0,
                        left: 0,
                        height: "100%",
                        objectFit: "cover",
                      }}
                    />
                  </>
                )}
              </div>
            </div>
            <div className=" mt-3 ">
              <h6 className="text-black fw-bold fs-075 mb-2 border-bottom pb-2">
                {amusementName}
              </h6>
              {hasReserveDetail_V2 ? (
                <div className="d-flex align-items-center justify-content-around">
                  {originalPrice > price && (
                    <div>
                      <span className="text-black-06 fs-07 text-decoration-line-throught-rotate border-secondary">
                        <SplitNumber number={originalPrice} />
                      </span>
                    </div>
                  )}
                  <div className=" fw-bold fs-085 pb-1 pt-1">
                    <SplitNumber number={price} />
                    <span className="medium-svg ">
                      <IconTooman style={{ marginTop: "-7px" }} />
                    </span>
                  </div>
                </div>
              ) : (
                <div className="fs-075 text-black-06">عدم امکان رزرو</div>
              )}
            </div>
          </Card.Body>
          <Card.Footer className="bg-white border-top-0 pt-0 px-2 text-center rounded-3">
            {hasReserveDetail_V2 ? (
              <>
                <button
                  className="btn-outline-success btn btn-sm small-svg  rounded-2 fs-07 text-white w-90"
                  style={{ background: "rgb(233 251 245)" }}
                >
                  <IconBasket1 fillColor="#09a463cc" />

                  <span className="ps-1">خرید بلیط</span>
                </button>
              </>
            ) : (
              <div className=" fs-07">
                <IconErrorCircle fillColor="#444" />
                در حال حاضر رزرو غیرفعال است
              </div>
            )}
          </Card.Footer>
        </Card>
      </Link>
    </Col>
  ) : (
    <div className="my-1 col-custom">
      <Link to={amusementUrl}>
        <Card className="p-2 rounded-3 shadow-sm border text-center h-100">
          <div>
            <div
              ref={ref}
              style={{ position: "relative", width: "100%", height: "140px" }}
            >
              {/* تصویر پیش‌فرض (همیشه نمایش داده می‌شود) */}
              <img
                src={placeHolderimage}
                data-src={`${imageUrl}?width=200`}
                altBot={amusementName}
                alt=""
                aria-hidden="true"
                className="rounded-3 mb-1 w-100"
                style={{
                  display: isImageLoaded ? "none" : "block", // پس از لود عکس اصلی، مخفی می‌شود
                  objectFit: "cover",
                  height: "100%",
                  backgroundColor: "#f5f5f5", // رنگ پس‌زمینه برای حالت Placeholder
                }}
              />

              {/* تصویر اصلی (فقط وقتی در viewport باشد لود می‌شود) */}
              {inView && (
                <>
                  <img
                    src={`${imageUrl}?width=200`}
                    alt={amusementName}
                    className={`rounded-3 mb-1 w-100 ${
                      isImageLoaded ? "visible" : "invisible"
                    }`}
                    loading="lazy"
                    onLoad={() => setIsImageLoaded(true)} // وقتی عکس لود شد، state را آپدیت می‌کند
                    style={{
                      position: "absolute",
                      top: 0,
                      left: 0,
                      height: "100%",
                      objectFit: "cover",
                    }}
                  />
                </>
              )}
            </div>
          </div>
          <Card.Body className="px-0 pb-0">
            <h6 className="text-black fw-bold fs-normal pb-3 border-bottom">
              {amusementName}
            </h6>

            {hasReserveDetail_V2 ? (
              ""
            ) : (
              <div className="text-secondary">عدم امکان رزرو</div>
            )}
          </Card.Body>
          {hasReserveDetail_V2 ? (
            <Card.Footer className="bg-white border-0 ">
              <Row className="gx-0">
                <Col
                  xs="12"
                  className="my-auto d-flex align-items-center justify-content-around"
                >
                  {originalPrice > price && (
                    <div>
                      <span className="text-black-06 fs-08 text-decoration-line-throught-rotate border-secondary">
                        <SplitNumber number={originalPrice} />
                      </span>
                    </div>
                  )}
                  <div className="fw-bold text-black medium-svg">
                    <span className=" text-dark">
                      <SplitNumber number={price} />
                    </span>
                    <IconTooman style={{ marginTop: "-7px" }} />
                  </div>
                </Col>
                <Col xs="12" className="mt-2">
                  <AddToBasketRoundedButton
                  // onClick={handleClick}
                  />
                </Col>
              </Row>
            </Card.Footer>
          ) : (
            <Card.Footer className="bg-white border-0 fs-07">
              <IconErrorCircle fillColor="#444" />
              در حال حاضر رزرو غیرفعال است
            </Card.Footer>
          )}
        </Card>
      </Link>
    </div>
  );
}

export default CardItem;
